import client from '@/api/client';
import { gql } from '@apollo/client';
import utils from '@/utils/auth';

const googleInit = () => new Promise((resolve) => {
  window.google.accounts.id.initialize({
    client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
    callback: resolve,
  });

  window.google.accounts.id.renderButton(
    document.getElementsByClassName('g_id_signin')[0],
    {
      theme: 'outline', size: 'large', width: 156, text: 'signin_with',
    },
  );

  window.google.accounts.id.prompt();
});

const siteRegistration = (data: {
  username: string;
  password: string;
}) => client
  .mutate({
    mutation: gql`
      mutation userRegistration(
          $username: String,
          $password: String,
      ) {
          userRegistration(
              username: $username,
              password: $password,
          ) {
              status
          }
      }
  `,
    variables: {
      username: data.username,
      password: data.password,
    },
  });

const sitePayRegistration = (data: {
  username: string;
  password: string;
}) => client
  .mutate({
    mutation: gql`
      mutation userPayRegistration(
          $username: String,
          $password: String,
          $notFree: Boolean,
      ) {
        userPayRegistration(
              username: $username,
              password: $password,
              notFree: $notFree,
          ) {
              status
          }
      }
  `,
    variables: {
      username: data.username,
      password: data.password,
      notFree: true,
    },
  });

const siteAuth = (data: {
  username: string;
  password: string;
}) => client
  .mutate({
    mutation: gql`
      mutation TokenAccess(
        $username: String,
        $password: String,
      ) {
        tokenAccess(
          username: $username,
          password: $password,
        ) {
          access_token
          refresh_token
          status
        }
      }
    `,
    variables: {
      username: data.username,
      password: data.password,
    },
  });

const siteAuthRestore = (data: {
  username: string;
  hash: string;
}) => client
  .mutate({
    mutation: gql`
      mutation TokenAccessRestore(
        $username: String,
        $hash: String,
      ) {
        tokenAccessRestore(
          username: $username,
          hash: $hash,
        ) {
          access_token
          refresh_token
          status
        }
      }
    `,
    variables: {
      username: data.username,
      hash: data.hash,
    },
  });

const siteAuthRefresh = () => client
  .mutate({
    mutation: gql`
      mutation Token(
        $refreshToken: String,
      ) {
        tokenRefresh(
          refreshToken: $refreshToken,
        ) {
          access_token
          refresh_token
          status
        }
      }
    `,
    variables: {
      refreshToken: utils.getRefreshToken(),
    },
  });

export default {
  googleInit,
  siteAuth,
  siteAuthRestore,
  siteAuthRefresh,
  siteRegistration,
  sitePayRegistration,
};
